import React, { useState } from 'react';
import clsx from 'clsx';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  makeStyles
} from '@material-ui/core';

import { FixMeLaterApi } from 'src/types';
import { Supplier } from 'src/types/supplier';
import ViewContactsDialog from './components/ViewContactDialog';

interface Props {
  className?: string;
  suppliers: Supplier[];
  onSupplierPress: (id: number) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {},
  avatar: {
    marginRight: theme.spacing(2)
  },
  addressCell: {
    width: 400
  },
  tableHead: {
    '& .MuiTableCell-root': {
      borderBottom: '2px solid #AEB4BE'
    }
  },
  tableRow: {
    borderBottom: '1px solid #AEB4BE'
  },
  tableCell: {
    borderBottom: 'none'
  }
}));

const Suppliers = ({
  className,
  suppliers,
  onSupplierPress,
  ...rest
}: Props) => {
  const classes = useStyles();

  const [selectedSupplier, setSelectedSupplier] = useState<Supplier | null>(
    null
  );
  const [viewContactsOpen, setViewContactsOpen] = useState(false);

  const handleViewContacts = (supplier: Supplier) => {
    setSelectedSupplier(supplier);
    setViewContactsOpen(true);
  };

  const handleCloseContacts = () => {
    setViewContactsOpen(false);
  };

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
      style={{ border: '1px solid #AEB4BE' }}
    >
      <PerfectScrollbar>
        <Box minWidth={1050}>
          <Table>
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Contacts</TableCell>
                <TableCell>Terms</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {suppliers.map((item: FixMeLaterApi) => (
                <TableRow hover key={item.id} className={classes.tableRow}>
                  <TableCell
                    onClick={() => onSupplierPress(item?.id)}
                    key={item.id}
                    className={classes.tableCell}
                    style={{ cursor: 'pointer' }}
                  >
                    <div>{item.name}</div>
                    <div>{item.company_name}</div>
                  </TableCell>
                  <TableCell
                    className={`${classes.addressCell} ${classes.tableCell}`}
                  >
                    {item.address}
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    <span
                      style={{
                        cursor: 'pointer',
                        textDecoration: 'none',
                        color: '#2F80ED'
                      }}
                      onClick={() => handleViewContacts(item)}
                    >
                      View Contacts
                    </span>
                  </TableCell>
                  <TableCell className={classes.tableCell}>
                    {item.terms}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>
      {selectedSupplier && (
        <ViewContactsDialog
          open={viewContactsOpen}
          onClose={handleCloseContacts}
          supplier={selectedSupplier}
        />
      )}
    </Card>
  );
};

export default Suppliers;
